<template>
  <el-progress class="zyc-charts-table-progress" :show-text="false" :percentage="num > 100 ? 100 : num" define-back-color="rgba(0, 0, 0, 0)" :color="'linear-gradient(360deg, #008CDC 0%, #02FEFF 100%);'"></el-progress>
</template>
<script>
export default {
  name: 'zycProgress',
  model: {
  },
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      num: 0
    }
  },
  watch: {
    percentage: {
      handler: function (newVal, oldVal) {
        this.init()
      },
      immediate: true
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    init: function () {
      var that = this
      that.num = 0
      if (this.percentage != 0) {
        let timer = setInterval(function () {
          that.num = that.num + 5
          if (that.num >= Number(that.percentage)) {
            clearInterval(timer)
          }
        }, 3)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/other/progress.vue